<div>
  <div class="user-bookclub__main">
    <opac-user-title [title]="bookClubName"></opac-user-title>

    <div class="user-bookclub__actions">
      <button *ngIf="showGoToOleButton" mat-flat-button class="accent user-bookclub__access" (click)="goToBookClub(bookClubSectionHome)">
        <span class="odilo-icon">bookclub</span>
        {{ 'user.bookclub.access' | translate: { brandingName: bookClubName } }}
      </button>

      <button
        mat-flat-button
        class="accent transparent user-bookclub__add"
        *ngIf="canCreateExperiences"
        (click)="goToBookClub(bookClubSectionCreate)">
        {{ 'user.create.experience' | translate }}
      </button>
      <button
        mat-flat-button
        class="accent transparent user-bookclub__grades"
        (click)="goToBookClub(bookClubSectionGrades)">
        {{ 'user.bookclub.profile.grades' | translate }}
      </button>
      <button
        mat-flat-button
        class="accent transparent user-bookclub__certificate"
        (click)="goToBookClub(bookClubSectionCertificates)">
        {{ 'user.bookclub.profile.certificates' | translate }}
      </button>
    </div>

    <ng-container *ngIf="!loading && allBookClubsEmpty">
      <opac-no-results [label]="'user.bookclub.noclubs' | translate">
        <opac-no-results-cta>
          {{ 'cta.bookclub' | translate }}
          <opac-button type="secondary" (click)="exploreLearningExperiences()">
            {{ learningExperiencesButtonLabel | translate }}
          </opac-button>
        </opac-no-results-cta>
      </opac-no-results>
    </ng-container>

    <div *ngIf="oleTimeout" class="ole-timeout">
      {{ 'user.bookclub.timeout' | translate: { brandingName: oleTimeoutName } }}

      <button mat-flat-button class="accent user-bookclub__access" (click)="goToBookClub(bookClubSectionHome)">
        <span class="odilo-icon">bookclub</span>
        {{ 'user.bookclub.access' | translate: { brandingName: bookClubName } }}
      </button>
    </div>

    <ng-container *ngIf="!oleTimeout && bookClubsCollection">
      <ng-container *ngFor="let carousel of bookClubsCollection">
        <app-slider-book-clubs
          *ngIf="carousel.bookClubs.length"
          [title]="getBookClubName(carousel)"
          [items]="carousel.bookClubs"></app-slider-book-clubs>
      </ng-container>
    </ng-container>
  </div>
</div>
